module.exports = __webpack_public_path__ + "8e903e31c59d1ea094dbfad8f1127762.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanWebPro-Bold.eot
// module id = 170
// module chunks = 0